// AuthService.ts
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RoleService } from '../services/roles.service';

@Injectable({
  providedIn: 'root'
})
export class RoleAuthService {
  permissions: any[] = []
  constructor(private roleService: RoleService) { }

  getUserPermissions(userId: any): Observable<any[]> {
    return this.roleService.GetRoleById(userId).pipe(
      map((roles: any) => this.mapRolesToPermissions(roles))
    );
  }

  private mapRolesToPermissions(roles: any): any[] {
    this.permissions = [];
    roles.data.permission.forEach((role: any) => {
      this.permissions = this.permissions.concat([role.permission_id]);
    });
    return this.permissions;
  }

  hasPermission(permission: string): any {
    return this.permissions.includes(permission);
  }
}
